module.exports = __webpack_public_path__ + "static/media/like.360b17a9.svg";